import React from 'react';
import Button from '@material-ui/core/Button';
import chromajs from 'chroma-js'
import makeStyles from '@material-ui/core/styles/makeStyles';

export const useStyles = makeStyles(theme => ({
	root: {
		backgroundColor: theme.palette.primary.main,
		color: ({btnDef}) => _.get(theme.palette, btnDef && btnDef.color) || theme.palette.common.white,
		borderRadius: 10,
		borderColor: theme.palette.primary.dark,
		textTransform: 'none',
		padding: theme.spacing(0.5, 1),
		overflow: 'hidden',
		'&:hover': {
			backgroundColor: chromajs(theme.palette.primary.main).darken(0.2).hex(),
		},
	},
	label: {
		maxHeight: 20,
	},
}), {name: 'TopNavBarButton'});

export const TopNavBarButton = ({btnDef, ...props}) => {
	const classes = useStyles({btnDef});
	return <Button {...props} classes={classes}/>;
};